<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-21 15:20:44
 * @LastEditTime: 2021-08-06 12:21:39
 * @LastEditors: chenguobiao
-->
<template>
  <div class="answer-detail">
    <!-- 国际象棋实战对决 -->
    <template v-if="questionType === 'ai'">
      <div class="answer-detail__fight flex flex-col">
        <div class="title flex items-center justify-center">
          <div class="title__icon">
            <img src="@/render/assets/images/grading/fight_icon.png">
          </div>
          <div class="title__txt">对战信息</div>
        </div>
        <div class="content">
          <div class="flex justify-between"  v-for="(item, index) in pgn" :key="index">
            <span>{{ item.step }}</span><span>{{ item.from }}</span><span>{{ item.to }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['questionType', 'pgn']
}
</script>

<style lang="scss" scoped>
  .answer-detail {
    margin-left: val(24);
    &__fight {
      width: val(324);
      height: val(738);
      background: url("../../../assets/images/grading/fight_detail_bg.png") no-repeat left top;
      background-size: 100% 100%;
      .title {
        padding-top: val(44);
        &__icon {
          width: val(30);
        }
        &__txt {
          font-size: val(24);
          font-weight: 400;
          color: #AE8967;
        }
      }
      .content {
        margin: val(24) 0 val(30);
        overflow: auto;
        &>div {
          padding: 0 val(57);
          margin-bottom: val(16);
          span {
            font-size: val(24);
            color: #AE8967;
            &:first-of-type {
              width: 33%;
            }
            &:nth-of-type(2) {
              width: 34%;
              text-align: left;
            }
            &:nth-of-type(3) {
              width: 33%;
              text-align: right;
            }
          }
        }
      }
    }
  }
</style>
